import clsx from "clsx";

import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "common/components/ui/Accordion";

import type { Icon } from "@phosphor-icons/react";
import type { JSX, ReactNode } from "react";

export default function SelectionFilter({
  label,
  tagsComponent,
  children,
  icon: Icon = null,
}: {
  label: string;
  tagsComponent: JSX.Element;
  children: ReactNode;
  icon?: Icon;
}) {
  return (
    <AccordionItem
      value={label}
      key={label}
      className="group border-0 transition-colors data-[state=open]:bg-white"
    >
      <AccordionTrigger className="flex items-center justify-between gap-x-1.5 px-4 py-2.5 text-sm-bold">
        {Icon && <Icon weight="fill" size={20} />}
        {label}
      </AccordionTrigger>
      {tagsComponent}
      <AccordionContent className="flex flex-col gap-y-1.5 px-2 pb-2 pt-1.5">
        {children}
      </AccordionContent>
      <div
        className={clsx(
          "mx-2 h-px bg-black-200 group-last:hidden group-data-[state=open]:mx-0",
          tagsComponent && "group-data-[state=closed]:mt-1.5",
        )}
      />
    </AccordionItem>
  );
}
